// src/components/editors/FontSelector.js
import React from 'react';

/**
 * FontSelector - Font picker showing each font rendered in itself.
 *
 * @param {string} selectedFontId - Currently selected font ID
 * @param {function} onChange - Callback when selection changes
 * @param {array} fontOptions - Array of font option objects
 */
const FontSelector = ({ selectedFontId, onChange, fontOptions }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-3">
        Font Style
      </label>

      <div className="grid grid-cols-2 gap-3">
        {fontOptions.map((font) => {
          const isSelected = selectedFontId === font.id;
          return (
            <button
              key={font.id}
              type="button"
              onClick={() => onChange(font.id)}
              className="relative rounded-lg border-2 text-left transition-all"
              style={{
                padding: '14px 12px 12px',
                borderColor: isSelected ? '#7c3aed' : '#E5E7EB',
                backgroundColor: isSelected ? '#F5F3FF' : '#FFFFFF',
              }}
            >
              {/* "Aa" sample */}
              <div
                style={{
                  fontFamily: font.headingFont,
                  fontSize: '30px',
                  fontWeight: 600,
                  lineHeight: 1,
                  color: isSelected ? '#7c3aed' : '#1F2937',
                  marginBottom: '8px',
                }}
              >
                Aa
              </div>

              {/* Font name in that font */}
              <div
                style={{
                  fontFamily: font.headingFont,
                  fontSize: '12px',
                  fontWeight: 600,
                  color: isSelected ? '#6D28D9' : '#374151',
                  marginBottom: '3px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {font.name}
              </div>

              {/* Category label */}
              <div
                style={{
                  fontSize: '11px',
                  color: '#9CA3AF',
                  fontFamily: 'system-ui, sans-serif',
                }}
              >
                {font.category}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FontSelector;
